import SiteEditFormValidator from "./site-edit-form-validator.js"

App.setupEditSiteForm = function () {
  const validator = new SiteEditFormValidator();
  validator.register();
}
